// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as PlaceDelete from "./PlaceDelete.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  if (field === "CreatedAt") {
    return state.createdAt;
  } else {
    return state.name;
  }
}

function set(state, field, value) {
  if (field === "CreatedAt") {
    return {
      createdAt: value,
      name: state.name
    };
  } else {
    return {
      createdAt: state.createdAt,
      name: value
    };
  }
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function BasicInfoDialog(props) {
  let onSubmit = props.onSubmit;
  let initialValues = props.initialValues;
  let form = Form.use(initialValues, Validators$1.schema([
    Validators$1.required("Name"),
    Validators$1.required("CreatedAt")
  ]), param => {
    onSubmit(param.state.values);
  }, undefined, undefined, "OnDemand", undefined);
  let match = React.useState(() => "Hidden");
  let setDialog = match[1];
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba";
  }
  let tmp$1;
  tmp$1 = match[0] === "Hidden" ? null : <PlaceDelete.make
      onConfirm={props.onPlaceDelete}
      onDismiss={() => setDialog(param => "Hidden")}
      placeName={initialValues.name}
    />;
  return <>
    <DialogForm.make
      formId={"basic_info"}
      heading={"Základní údaje místa"}
      onDismiss={props.onDismiss}
      visible={true}
    >
      <Form.Provider.make
        value={form}
      >
        <form
          id={"basic_info"}
          onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
        >
          <fieldset
            className={`reset ` + Styles.fieldset.grid}
          >
            <Form.Field.make
              field={"Name"}
              render={field => <InputWrapper.make
                inputError={field.error}
                inputName={"name"}
                inputSlot={<input
                  type={"text"}
                  value={field.value}
                  onChange={ReForm__Helpers.handleChange(field.handleChange)}
                />}
                labelSlot={"Název"}
              />}
            />
            <Form.Field.make
              field={"CreatedAt"}
              render={field => <InputWrapper.make
                inputError={field.error}
                inputName={"created"}
                inputSlot={<input
                  type={"date"}
                  value={field.value}
                  onChange={ReForm__Helpers.handleChange(field.handleChange)}
                />}
                labelSlot={"Založeno"}
              />}
            />
          </fieldset>
        </form>
        {tmp}
        <div>
          <button
            className={Styles.button.variantDanger}
            type={"button"}
            onClick={param => setDialog(param => "PlaceDelete")}
          >
            {"Smazat místo"}
          </button>
        </div>
      </Form.Provider.make>
    </DialogForm.make>
    {tmp$1}
  </>;
}

let make = BasicInfoDialog;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
